
import { Box, Grid2, Typography } from "@mui/material";
import { useGetUserSummerPurchaseDetail } from "../../assets/api/UseStudentGetApi";
import CustomDivider from "../../shared/utils/CustomDivider";
import { SlotCard } from "./StudentOnlineCourseDetail";
import { formatToAmPm } from "../../shared/formatter";
import { useParams } from "react-router-dom";
import { ImagePath, ImageRelativePath } from "../../shared/constants";

const StudentSummerCampDetail = () => {

    const { apartments_id,slug } = useParams();
    const { data, isLoading } = useGetUserSummerPurchaseDetail({ slug: slug ,apartments_id:apartments_id})
    if (isLoading) return <Typography>Loading...</Typography>;

    const course = data?.data?.[0];

    return (
        <Box>
            <Grid2 size={{ xs: 12, md: 5 }}>
                <Box
                    src={`${ImagePath}${ImageRelativePath}${course?.cover_image}`}
                    component={"img"}
                    sx={{
                        width: "100%",
                        height: 350,
                        objectFit: "cover",
                        borderRadius: "0.5rem"

                    }}
                />
            </Grid2>
            <CustomDivider size="1rem" />
            {/* Course Info */}
            <Typography variant="h4">
                {course?.course_name}
            </Typography>

            <Typography variant="body2">
                Apartment: {course?.apartment_name}
            </Typography>

            <CustomDivider size="1rem" />

            {course?.description && (
                <>
                    <Typography fontWeight={600}>Description</Typography>
                    <Typography variant="body2">
                        {course?.description}
                    </Typography>
                </>
            )}
            <CustomDivider size="1rem" />
            {course?.short_description && (
                <>
                    <Typography variant="body2">
                        {course?.short_description}
                    </Typography>
                </>
            )}
            <CustomDivider size="1rem" />
            {course?.learningoutcome && (
                <>
                    <Typography fontWeight={600}>Learning Outcome</Typography>
                    <Typography variant="body2">
                        {course?.learningoutcome}
                    </Typography>
                </>
            )}
            <CustomDivider size="1rem" />
            <Typography fontWeight={600}>Sessions:</Typography>
            {course?.sessions?.map((item, index) => (
              <SlotCard day={item?.day} timing={`${formatToAmPm(item?.start_time)}-${formatToAmPm(item?.end_time)}`}/>
            ))}

            <CustomDivider size="2rem" />


        </Box>
    );
};

export default StudentSummerCampDetail;




